import { Locale } from 'modules/i18n';

export const chainProjectsSectionTranslation = {
  [Locale.en]: {
    projects: 'Projects',
    name: 'Name',
    status: 'Project status',
    requests: 'Requests',
  },
};
